import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@quorum/api';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { InspectionService } from '../inspection.service';
import { VcrBaseComponent } from '../vcr-report-base.component';

@Component({
  selector: 'quorum-vcr-report-display-print',
  templateUrl: './vcr-report-display-print.component.html',
  styleUrls: ['./vcr-report-display-print.component.scss'],
})
export class VcrReportDisplayPrintComponent extends VcrBaseComponent implements OnInit {
  constructor(
    public inspectionService: InspectionService,
    public activatedRoute: ActivatedRoute,
    public authenticationStateService: AuthenticationStateService,
    public mediaService: MediaObserver,
    public breakpointObserver: BreakpointObserver,
    public systemControlStateService: SystemControlStateService,
    public apiService: ApiService
  ) {
    super(
      inspectionService,
      activatedRoute,
      authenticationStateService,
      mediaService,
      breakpointObserver,
      systemControlStateService,
      apiService
    );
  }
  ngOnInit() {
    this.Init();
  }
}
